<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('Description'), sort: 'Description' },
            { title: $t('UserName'), sort: 'UserName' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 32%">
              <div v-if="row.productInfo != null">
                {{ row.productInfo.persianName }}
              </div>
            </td>
            <td style="width: 27%">
              {{ row.description | truncate(60) }}
            </td>
            <td style="width: 15%">
              {{ row.userInfo.fullName }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
            <td style="width: 8%">
              <vs-button
                radius
                color="success"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-eye"
                @click.prevent="modifyComment(row)"
                class="d-inline"
                v-has-permission="permission185"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeModifyPopup"
    ></modify-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "Content_managment_ProductComments_Index",
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission185: "ModifyCmsCategory",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "CMS/api/CommentsQuery?commentStatus=0&",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    modifyComment(model) {
      this.modalModel = {
        id: model.id,
        description: model.description,
      };
      this.ModifyPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
